import { render, staticRenderFns } from "./RedeemTagDialog.vue?vue&type=template&id=b19f92e6&"
import script from "./RedeemTagDialog.vue?vue&type=script&lang=js&"
export * from "./RedeemTagDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports